import { Component } from '@angular/core';

@Component({
    selector: 'error-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    styles: []
})
export class PageNotFoundComponent {
    constructor() { }
}